var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIceland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4541C24.8366 32.4541 32 25.2907 32 16.4541C32 7.61755 24.8366 0.454102 16 0.454102C7.16344 0.454102 0 7.61755 0 16.4541C0 25.2907 7.16344 32.4541 16 32.4541Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.55127 20.6278C1.47702 24.0628 3.51733 27.0399 6.26096 29.148V20.6278H0.55127Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6089 32.393C15.0675 32.4325 15.5313 32.4539 16.0002 32.4539C23.3926 32.4539 29.613 27.4401 31.449 20.6278H14.6089V32.393Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.449 12.2802C29.613 5.46791 23.3926 0.454102 16.0002 0.454102C15.5313 0.454102 15.0675 0.475477 14.6089 0.514977V12.2802H31.449Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26096 3.76048C3.51733 5.8686 1.47702 8.84567 0.55127 12.2806H6.26096V3.76048Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 14.3672H12.5218H12.5218V0.83445C11.0431 1.16232 9.64131 1.69376 8.34781 2.39957V14.3671H0.135438C0.046375 15.0503 0 15.7468 0 16.4541C0 17.1615 0.046375 17.858 0.135438 18.5411H8.34775H8.34781V30.5086C9.64131 31.2144 11.0431 31.746 12.5218 32.0738V18.5413V18.5411H31.8646C31.9535 17.858 32 17.1615 32 16.4541C32 15.7468 31.9535 15.0503 31.8646 14.3672V14.3672Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceland);
export default __webpack_public_path__ + "static/media/iceland.3a082bc3.svg";
export { ForwardRef as ReactComponent };